module.exports = __webpack_public_path__ + "media/images/ambassador_banner-2ea3dc4379817732792fa0525ccc0a7c.jpg";